export const MESSAGES_NSU_REQUEST: Messages = {
  REQUEST_EMAIL: {
    SUCCESS: {
      variant: "default",
      description: "Comprovante de depósito solicitado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao solicitar comprovante de depósito!",
      duration: 5000,
      closeOnClick: true,
    },
  },
};

export const MESSAGES_NSU: Messages = {
  REQUEST_EMAIL: {
    SUCCESS: {
      variant: "default",
      description: "Comprovante de depósito solicitado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao solicitar comprovante de depósito!",
      duration: 5000,
      closeOnClick: true,
    },
  },
};


export const MESSAGES_CLOSE_CONCILIATION: Messages = {
  CAN_CLOSE: {
    SUCCESS: {
      variant: "default",
      description: "Conciliação fechada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao fechar conciliação!",
      duration: 5000,
      closeOnClick: true,
    },
  },
}
